import { useMemo } from 'react';

import { gridAvailableButtons, SendNotificationsButtonId } from './grid-available-buttons';
import { emptyArray } from 'ui-components/default-props/empty';
import { useBTEmailExperienceNew } from '../../hooks/use-seller-setting';

/**
 * @param {string} viewId
 * @returns {[]}
 */
export const useShipmentsGridAvailableButtonsForView = (viewId) => {
  const isSendNotificationsButtonUnavailable = useBTEmailExperienceNew();

  return useMemo(() => {
    const buttons = gridAvailableButtons[viewId] || emptyArray;

    return buttons.filter((button) => {
      switch (button.id) {
        case SendNotificationsButtonId:
          return !isSendNotificationsButtonUnavailable;
        default:
          return true;
      }
    });
  }, [isSendNotificationsButtonUnavailable, viewId]);
};
